// ** Utils
import { paginateArray } from '@utility/belt'

// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { combineReducers } from 'redux'


const appBaseURL = import.meta.env.VITE_APP_BASE_URL
// const appBaseURL = import.meta.env.VITE_APP_BASE_URL
// console.log(appBaseURL)
// ** START:  
export const getProdSvcTaxGroupListF01Data = createAsyncThunk('appProduct/getProdSvcTaxGroupListF01Data', async (params, thunkAPI) => {
    try {

        const state = thunkAPI.getState() 

        const { sort, sortColumn, page = 1, perPage = 10, q = '', caller = '' } = params

        // if (import.meta.env.DEV) {
        //     console.log(`Called by ${caller}`)
        // }

        let data
        let tempIsDataLoaded

        /* Note state.prodSvcTaxGroup is defined in 
        index.js or a js file 
        calling 
        const store = useSelector(state => state.prodSvcTaxGroup.prodSvcTaxGroupListF01) */
        if (!state.prodSvcTaxGroup.prodSvcTaxGroupListF01.isDataLoaded) {

            const response = await fetch(`${appBaseURL}/product/get-prodsvc-taxgroup-list-f01`)
            if (!response.ok) {
                throw new Error('Fetch response error at getProdSvcTaxGroupListF01Data', response.statusText)
            }
            // if (import.meta.env.DEV) {
            //     console.log('API call to /Product/getProdSvcTaxGroupListF01')
            // }

            data = await response.json()
            tempIsDataLoaded = true
        } else {

            data = state.prodSvcTaxGroup.prodSvcTaxGroupListF01.allData
            tempIsDataLoaded = state.prodSvcTaxGroup.prodSvcTaxGroupListF01.isDataLoaded
        }

        // Get from cache if isDataLoaded is false:
         
        const dataAsc = [...data].sort((a, b) => { // Pass a copy [...data] only to sort()
            let aValue, bValue
        
            // Handle cases where sortColumn might specify a nested property
            if (sortColumn.includes('.')) {
                const splitColumn = sortColumn.split('.')
                aValue = a[splitColumn[0]] ? a[splitColumn[0]][splitColumn[1]] : null
                bValue = b[splitColumn[0]] ? b[splitColumn[0]][splitColumn[1]] : null
            } else {
                aValue = a[sortColumn]
                bValue = b[sortColumn]
            }
        
            // Handling nulls - nulls will sort to the end
            if (aValue === null) return 1
            if (bValue === null) return -1
            if (aValue === null && bValue === null) return 0
        
            // General comparison
            return aValue < bValue ? -1 : aValue > bValue ? 1 : 0
        })
        
        // Determine the sorting direction
        const dataToFilter = sort === 'asc' ? dataAsc : dataAsc.reverse()

        const queryLowered = q.toLowerCase()

        const filteredData = dataToFilter.filter( 
            prodSvcTaxGroup => { 
                return ((
                // prodSvcTaxGroup._.toLowerCase().includes(queryLowered) ||
                // prodSvcTaxGroup._.toLowerCase().includes(queryLowered) ||
                prodSvcTaxGroup.prodSvcTaxGroup.toLowerCase().includes(queryLowered))
                )
            }
        )

        return {
            params,
            data: filteredData.length <= perPage ? filteredData : paginateArray(filteredData, perPage, page),
            allData: data,
            totalPages: filteredData.length, // TODO: Doesnt work:  Math.ceil(filteredData.length / perPage) or totalPages is a misnomer
            isDataLoaded: tempIsDataLoaded,
            caller
        }

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message)  

    }

})

export const prodSvcTaxGroupListF01Slice = createSlice({
    name: 'prodSvcTaxGroupListF01Slice',
    initialState: {
        params: {},
        data: [],
        allData: [],
        total: 0,
        totalPages: 0,
        loading: false, 
        isDataLoaded: false, // Controls caching mechanism to avoid unnecessary retrieval from DB 
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null 
    },

    reducers: {
        setIsDataLoaded: (state, action) => {
            state.isDataLoaded = action.payload
        }
    },

    extraReducers: builder => {
    builder.addCase(getProdSvcTaxGroupListF01Data.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.allData = action.payload.allData
        state.total = action.payload.totalPages
        state.params = action.payload.params
        state.loading = false
        // state.isDataLoaded = true is handled by async thunk's return
        state.isDataLoaded = action.payload.isDataLoaded || false // Take value from async thunk's return
        state.rejected = false
        state.error = null
    })
    builder.addCase(getProdSvcTaxGroupListF01Data.pending, (state) => {
        state.loading = true 
        state.rejected = false
        state.error = null
    })
    builder.addCase(getProdSvcTaxGroupListF01Data.rejected, (state, action) => {
        state.loading = false
        state.rejected = true
        state.error = action.error.message
        state.errActPload = action.payload
        state.errActMsg = action.error.message

        if (import.meta.env.DEV) {
            console.error(`Fetch failure at getProdSvcTaxGroupListF01Data as called by ${action.payload.caller}:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
        }
    })
    }
})

// ** START:  
export const getProdSvcTaxGroupRowF01Data = createAsyncThunk('appProduct/getProdSvcTaxGroupRowF01Data', async (id, thunkAPI) => {
    try {
        const response = await fetch(`${appBaseURL}/product/get-prodsvc-taxgroup-row-f01?rowId=${id}`)
        if (!response.ok) {
            throw new Error('Fetch response error at getProdSvcTaxGroupRowF01Data', response.statusText)
        }
        const data = await response.json()  
        return data  

    } catch (error) {
        if (import.meta.env.DEV) {
            console.error('Fetch failure at getProdSvcTaxGroupRowF01Data try-catch:', error)
        }
        return thunkAPI.rejectWithValue(error.message)  
    }
})

export const prodSvcTaxGroupRowF01Slice = createSlice({
    name: 'prodSvcTaxGroupRowF01Slice',
    initialState: {
        data: null,
        loading: false,
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null
    },
    // reducers: {},
    extraReducers: (builder) => {
    builder
        .addCase(getProdSvcTaxGroupRowF01Data.fulfilled, (state, action) => {
            state.data = action.payload
            state.loading = false
            state.rejected = false
            state.error = null
        })
        .addCase(getProdSvcTaxGroupRowF01Data.pending, (state) => {
            state.loading = true
            state.rejected = false
            state.error = null
        })
        .addCase(getProdSvcTaxGroupRowF01Data.rejected, (state, action) => {
            state.loading = false
            state.rejected = true
            state.error = action.error.message
            state.errActPload = action.payload
            state.errActMsg = action.error.message
            if (import.meta.env.DEV) {
                console.error(`Fetch failure at getProdSvcTaxGroupRowF01Data:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
            }
        })
    }
})


// ** START Update
export const updateProdSvcTaxGroup = createAsyncThunk('appProduct/updateProdSvcTaxGroup', async ({id, modifiedFields}, thunkAPI) => {
    try {
        const response = await fetch(`${appBaseURL}/product/update-prodsvc-taxgroup/${id}`, {
            method: 'PUT', 
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(modifiedFields)
        })

        // console.log(process.env.NODE_ENV)
        if (response.ok) {
            if (response.status === 204) { 
                // Update successful. No Content returned from endpoint
                return null
            } else {
                const data = await response.json()
                return data
            }
        } else {
            return thunkAPI.rejectWithValue(await response.json())
        }

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message)
    }
})

export const prodSvcTaxGroupUpdateSlice = createSlice({
    name: 'prodSvcTaxGroupUpdateSlice',
    initialState: {
        data: null,
        loading: false,
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null
    },
    // reducers: {},
    extraReducers: (builder) => {
    builder
        .addCase(updateProdSvcTaxGroup.fulfilled, (state, action) => {
            state.data = action.payload
            state.loading = false
            state.rejected = false
            state.error = null
        })
        .addCase(updateProdSvcTaxGroup.pending, (state) => {
            state.loading = true
            state.rejected = false
            state.error = null
        })
        .addCase(updateProdSvcTaxGroup.rejected, (state, action) => {
            state.loading = false
            state.rejected = true
            state.error = action.error.message
            state.errActPload = action.payload
            state.errActMsg = action.error.message
            if (import.meta.env.DEV) {
                console.error(`Update failure at updateProdSvcTaxGroup:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
            }
        })
    }
})


// ** START Create
export const createProdSvcTaxGroup = createAsyncThunk('appProduct/createProdSvcTaxGroup', async ({modifiedFields}, thunkAPI) => {
    try {
        const response = await fetch(`${appBaseURL}/product/create-prodsvc-taxgroup`, {
            method: 'POST', 
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(modifiedFields)
        })

        if (response.ok) {
            if (response.status === 204) { 
                    // Creation successful. No Content returned from endpoint
                    return null
            } else {
                const data = await response.json()
                return data
            }
        } else {
            return thunkAPI.rejectWithValue(await response.json())
        }

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message)
    }
})

export const prodSvcTaxGroupCreateSlice = createSlice({
    name: 'prodSvcTaxGroupCreateSlice',
    initialState: {
        data: null,
        fulfilled: false,
        loading: false,
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null
    },
    reducers: {
        resetCreateState: (state) => {
            state.data = null
            state.fulfilled = false
            state.loading = false
            state.rejected = false
            state.error = null
            state.errActPload = null
            state.errActMsg = null
        }
    },
    extraReducers: (builder) => {
    builder
        .addCase(createProdSvcTaxGroup.fulfilled, (state, action) => {
            state.data = action.payload
            state.fulfilled = true
            state.loading = false
            state.rejected = false
            state.error = null
            if (import.meta.env.DEV) {
                console.log(`Success at createProdSvcTaxGroup:\n Data: ${JSON.stringify(state.data, null, 2)}`)
            }
        })
        .addCase(createProdSvcTaxGroup.pending, (state) => {
            state.fulfilled = false
            state.loading = true
            state.rejected = false
            state.error = null
        })
        .addCase(createProdSvcTaxGroup.rejected, (state, action) => {
            state.fulfilled = false
            state.loading = false
            state.rejected = true
            state.error = action.error.message
            state.errActPload = action.payload
            state.errActMsg = action.error.message
            if (import.meta.env.DEV) {
                console.error(`Create failure at createProdSvcTaxGroup\:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
            }
        })
    }
})


// ** START Delete
export const deleteProdSvcTaxGroup = createAsyncThunk('appProduct/deleteProdSvcTaxGroup', async (id, thunkAPI) => {
    try {
        const response = await fetch(`${appBaseURL}/product/delete-prodsvc-taxgroup/${id}`, {
            method: 'DELETE', 
            headers: { 
                'Content-Type': 'application/json'
                // TBI: 'Authorization': 'Bearer ' + AccessToken 
            }
        })

        if (response.ok) {
            if (response.status === 204) { 
                // Update successful. No Content returned from endpoint
                return null
            } else {
                const data = await response.json()
                return data
            }
        } else {
            return thunkAPI.rejectWithValue(await response.json())
        }

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message)
    }
})

export const prodSvcTaxGroupDeleteSlice = createSlice({
    name: 'prodSvcTaxGroupDeleteSlice',
    initialState: {
        data: null,
        loading: false,
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null
    },
    // reducers: {},
    extraReducers: (builder) => {
    builder
        .addCase(deleteProdSvcTaxGroup.fulfilled, (state, action) => {
            state.data = action.payload
            state.loading = false
            state.rejected = false
            state.error = null
        })
        .addCase(deleteProdSvcTaxGroup.pending, (state) => {
            state.loading = true
            state.rejected = false
            state.error = null
        })
        .addCase(deleteProdSvcTaxGroup.rejected, (state, action) => {
            state.loading = false
            state.rejected = true
            state.error = action.error.message
            state.errActPload = action.payload
            state.errActMsg = action.error.message
        if (import.meta.env.DEV) {
            console.error(`Delete failure at deleteProdSvcTaxGroup:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
        }
        })
    }
})

// Used for dropdown menu:
export const getProdSvcTaxGroupListF02Data = createAsyncThunk('appProduct/getProdSvcTaxGroupListF02Data', async (params, thunkAPI) => {
    try {

        const response = await fetch(`${appBaseURL}/product/get-prodsvc-taxgroup-list-f02`)
        if (!response.ok) {
            throw new Error('Fetch response error at getProdSvcTaxGroupListF02Data', response.statusText)
        }

        const data = await response.json()

        return {
            params,
            data
        }

    } catch (error) {
        console.log(error.message)
        return thunkAPI.rejectWithValue(error.message)  
    }

})

export const prodSvcTaxGroupListF02Slice = createSlice({
    name: 'prodSvcTaxGroupListF02Slice',
    initialState: {
        params: {},
        data: [],
        total: 0,
        loading: false, 
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null 
    },

    extraReducers: builder => {
    builder.addCase(getProdSvcTaxGroupListF02Data.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.loading = false
        state.rejected = false
        state.error = null
    })
    builder.addCase(getProdSvcTaxGroupListF02Data.pending, (state) => {
        state.loading = true 
        state.rejected = false
        state.error = null
    })
    builder.addCase(getProdSvcTaxGroupListF02Data.rejected, (state, action) => {
        state.loading = false
        state.rejected = true
        state.error = action.error.message
        state.errActPload = action.payload
        state.errActMsg = action.error.message

        if (import.meta.env.DEV) {
            console.error(`Fetch failure at getProdSvcTaxGroupListF02Data:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
        }
    })
    }
})

// Export actions
export const { setIsDataLoaded } = prodSvcTaxGroupListF01Slice.actions
export const { resetCreateState } = prodSvcTaxGroupCreateSlice.actions

// Combine reducers
const prodSvcTaxGroupReducer = combineReducers({
    prodSvcTaxGroupListF01: prodSvcTaxGroupListF01Slice.reducer,
    prodSvcTaxGroupListF02: prodSvcTaxGroupListF02Slice.reducer,
    prodSvcTaxGroupRowF01: prodSvcTaxGroupRowF01Slice.reducer,
    prodSvcTaxGroupCreate: prodSvcTaxGroupCreateSlice.reducer,
    prodSvcTaxGroupUpdate: prodSvcTaxGroupUpdateSlice.reducer,
    prodSvcTaxGroupDelete: prodSvcTaxGroupDeleteSlice.reducer
})


export default prodSvcTaxGroupReducer